<template>
  <div class="price">
    <template v-if="propertyDetail.type === 'business'">
      <div class="price-property">
        <span class="title">{{$t('property_price')}}</span><span class="text">{{formatPrice(propertyDetail.property_price)}}</span>
      </div>
      <div class="price-other">
        <div class="price-building" v-if="propertyDetail.land_price">
          <span class="title">{{$t('building_price')}}</span><span class="text">{{formatPrice(propertyDetail.building_price)}}</span>
        </div>
        <div class="price-land" v-if="propertyDetail.land_price">
          <span class="title">{{$t('land_price')}}</span><span class="text">{{formatPrice(propertyDetail.land_price)}}</span>
        </div>
        <div class="price-yield" v-if="propertyDetail.yields">
          <span class="title">{{$t('yields')}}</span><span class="text">{{formatPercentage(propertyDetail.yields)}}</span>
        </div>
      </div>
    </template>
    <template v-else-if="['rental-residential', 'rental-commercial'].includes(propertyDetail.type)">
      <div class="price-property">
        <div v-if="propertyDetail.rent">
          <span class="title">{{$t('rent')}}</span>
          <span class="text">{{propertyDetail.rent}}</span>
        </div>
        <div v-if="propertyDetail.administrative_fee">
          <span class="title">{{$t('administrative_fee')}}</span>
          <span class="text">{{propertyDetail.administrative_fee}}</span>
        </div>
      </div>
      <div class="price-other">
        <div class="price-deposit" v-if="propertyDetail.security_deposit">
          <span class="title">{{$t('security_deposit')}}</span>
          <span class="text">{{propertyDetail.security_deposit}}</span>
        </div>
        <div class="price-keymoney" v-if="propertyDetail.key_money">
          <span class="title">{{$t('key_money')}}</span>
          <span class="text">{{propertyDetail.key_money}}</span>
        </div>
        <template v-if="propertyDetail.type === 'rental-residential'">
          <div class="price-brokeragefee" v-if="propertyDetail.intermediary_charge">
            <span class="title">{{$t('intermediary_charge')}}</span>
            <span class="text">{{propertyDetail.intermediary_charge}}</span>
          </div>
          <div class="price-floorplan" v-if="propertyDetail.floor_plan_details">
            <span class="title">{{$t('floor_plan_details')}}</span>
            <span class="text" v-html="sanitize(propertyDetail.floor_plan_details)"></span>
          </div>
        </template>
        <template v-if="propertyDetail.type === 'rental-commercial'">
          <div class="price-brokeragefee" v-if="propertyDetail.guarantee_deposit">
            <span class="title">{{$t('guarantee_deposit')}}</span>
            <span class="text">{{propertyDetail.guarantee_deposit}}</span>
          </div>
          <div class="price-floorplan" v-if="propertyDetail.occupied_area || propertyDetail.land_area">
            <span class="title">{{$t('occupied_area')}}／{{$t('land_area')}}</span>
            <span class="text" v-html="ol_html"></span>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: [
    'propertyDetail'
  ],
  methods: {
    formatPrice: function (price, withBracket = false) {
      const p = Number(price)

      if (Number.isNaN(p) || p === 0) return ''

      const priceString = p.toLocaleString() + ' ' + this.$t('yen')
      return withBracket ? `（${priceString}）` : priceString
    },
    formatPercentage: function (value) {
      const p = Number(value)

      if (Number.isNaN() || p === 0) return ''
      return `${p}%`
    },
    sanitize: function (text) {
      if (!text) return text
      return text.replace(/\n/g, '<br />')
    }
  },
  computed: {
    ol_html: function () {
      const values = []
      if (this.propertyDetail.occupied_area) values.push(this.$t('occupied_area') + ': ' + this.propertyDetail.occupied_area)
      if (this.propertyDetail.land_area) values.push(this.$t('land_area') + ': ' + this.propertyDetail.land_area)
      return values.join('　')
    }
  }
}
</script>
